// extracted by mini-css-extract-plugin
export var container = "_7o-0";
export var containerTopRight = "_7o-1";